import { hex2rgba } from '../utils/index';

export const cyprus = "#0A192F";
export const irisBlue ="#0AA8B9";
export const tropicalBlue ="#C7D1F1";
export const waikawaGrey ="#636D8F";
const purple = "#D901FF";
const blue ="#0151A9";
// const green = '#8BC34A';
// const greenSecondary = '#689F38';
// const amber = '#FFC107';
// const amberSecondary ='#FFCA28';
// const cyan = '#00BCD4';
// const cyanSecondary = '#26C6DA';
// const pink = '#E91E63';
// const pinkSecondary = '#EC407A';
// const orange = '#FFA726';
// const orangeSecondary = '#FF9800';
const primary = purple;
const secondary = blue;



export const theme = {
    colors: {
        blue: blue,
        darkNavy: '#020c1b',
        navy: '#0a192f',
        lightNavy: '#172a45',
        lightestNavy: '#303C55',
        slate: '#8892b0',
        lightSlate: '#a8b2d1',
        lightestSlate: '#ccd6f6',
        white: '#e6f1ff',
        purple: purple,
        bg: cyprus,
        primary:primary,
        secondary:secondary,
        transPrimary: hex2rgba(primary, 0.07),
        transPurple: hex2rgba(purple, 0.07),
        shadowNavy: hex2rgba('#020c1b', 0.7),
    },
    fonts: {
        Calibre:
            'Calibre, San Francisco, SF Pro Text, -apple-system, system-ui, BlinkMacSystemFont, Roboto, Helvetica Neue, Segoe UI, Arial, sans-serif',
        SFMono: 'SF Mono, Fira Code, Fira Mono, Roboto Mono, Lucida Console, Monaco, monospace',
    },
    fontSizes: {
        xs: '12px',
        smish: '13px',
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '20px',
        xxl: '22px',
        h3: '32px',
    },
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    transition: 'all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1)',

    borderRadius: '3px',
    navHeight: '100px',
    navScrollHeight: '70px',
    margin: '20px',

    tabHeight: 42,
    tabWidth: 120,
    radius: 3,

    hamburgerWidth: 30,
    hamBefore: `top 0.1s ease-in 0.25s, opacity 0.1s ease-in`,
    hamBeforeActive: `top 0.1s ease-out, opacity 0.1s ease-out 0.12s`,
    hamAfter: `bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19)`,
    hamAfterActive: `bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s`,

    navDelay: 1000,
    loaderDelay: 2000,
}

export default theme;